import JoditEditor, { Jodit } from "jodit-react";
import { useEffect, useMemo, useRef, useState } from "react";
import CONFIG from "app-config/config.json";

interface TextEditorProps {
  value: string;
  onChange: (data: any) => void;
  toolbarSticky?: boolean;
  maxHeight?: number | string;
  [x: string]: any;
}

const buttons = [
  "undo",
  "redo",
  "|",
  "bold",
  "strikethrough",
  "underline",
  "italic",
  "|",
  "superscript",
  "subscript",
  "|",
  "align",
  "|",
  "ul",
  "ol",
  "outdent",
  "indent",
  "|",
  // "font",
  "fontsize",
  "brush",
  "paragraph",
  "|",
  "image",
  "link",
  "table",
  "|",
  "hr",
  "eraser",
  "copyformat",
  "|",
  "fullsize",
  "selectall",
  // "print",
  // "|",
  // "source",
];
export const TextEditor = ({
  value,
  onChange,
  placeholder = "",
  toolbarSticky = false,
  maxHeight,
}: TextEditorProps) => {
  const editor = useRef<Jodit>(null);
  const defaultValueSet = useRef<boolean>(false);
  const [defaultValue, setDefaultValue] = useState(value);

  useEffect(() => {
    if (defaultValue && editor.current && !defaultValueSet.current) {
      editor.current.setEditorValue(defaultValue);
      defaultValueSet.current = true;
    }
  }, [defaultValue]);

  const config = useMemo(
    () => ({
      readonly: false,
      disablePlugins: ["mobile"],
      buttons: buttons,
      addNewLine: false,
      autofocus: false,
      toolbarSticky: false,
      maxHeight,
      placeholder: placeholder || "Start writing...",
      uploader: {
        insertImageAsBase64URI: false,
        imagesExtensions: ["jpg", "png", "jpeg"],
        format: "json",
        method: "POST",
        url: CONFIG.UPLOAD_API,
        prepareData: function (formData: FormData) {
          var file = formData.getAll('files[0]')[0];
          formData.delete('files[0]');
          formData.append('file', file);
          formData.delete('path');
          formData.delete('source');
          return formData;
        },
        isSuccess: function (resp: any) {
          if (!resp.error) {
            return true;
          }
          return {
            messages: "Error has occured!",
          };
        },
        process: function (res: any) {
          if (res.error) {
            return alert(res.error.message_en ?? "Error has occured!");
          }
          return res.result.img_url ?? "";
        },
        defaultHandlerSuccess: function (this: any, data: any, resp: any) {
          if (data) {
            this.selection.insertImage(data, null, "100%");
          }
        },
      },
    }),
    [maxHeight, placeholder]
  );
  return (
    <div className="reset-tw">
      <JoditEditor
        config={config}
        value={`${defaultValue}`}
        className={toolbarSticky ? "sticky-toolbar" : ""}
        onChange={onChange}
      />
    </div>
  );
};
